import type { SavasRaporu } from './rapor.js'

const yuzde = (o: number) => `${(o * 100).toFixed(0)}%`

export function Rapor({ rapor, oyuncuTarafi, tekrar }: {
  rapor: SavasRaporu
  oyuncuTarafi: 'a' | 'b'
  tekrar: () => void
}) {
  const kazandi = rapor.kazanan === oyuncuTarafi
  const dusman = oyuncuTarafi === 'a' ? 'b' : 'a'
  const bizim = rapor.hasarTuruDagilimi[oyuncuTarafi]
  const toplam = bizim.fiziksel + bizim.ruh

  return (
    <div className="rapor">
      <h2 className={kazandi ? 'kazandi' : 'kaybetti'}>
        {rapor.kazanan === null ? 'BERABERE' : kazandi ? 'ZAFER' : 'YENİLGİ'}
      </h2>
      <p className="ozet">{rapor.turSayisi} tur sürdü.</p>

      <div className="rapor-kutular">
        <div className="kutu">
          <h3>Hasar</h3>
          <div className="satir"><span>Sen</span><b>{rapor.tarafHasari[oyuncuTarafi]}</b></div>
          <div className="satir"><span>Rakip</span><b>{rapor.tarafHasari[dusman]}</b></div>
        </div>

        <div className="kutu">
          <h3>Hasar türün</h3>
          <div className="satir"><span>Fiziksel</span><b>{bizim.fiziksel}</b></div>
          <div className="satir"><span>Ruh</span><b>{bizim.ruh}</b></div>
          {toplam > 0 && (
            <p className="ipucu">
              {bizim.ruh === 0
                ? 'Hiç ruh hasarı vermedin — rakibin zırhı kalınsa tırpan/büyü dene.'
                : bizim.fiziksel === 0
                  ? 'Hiç fiziksel hasar vermedin — ruh direnci yüksek rakiplere karşı zorlanırsın.'
                  : 'İki hasar türünü de kullandın.'}
            </p>
          )}
        </div>

        <div className="kutu">
          <h3>İsabet</h3>
          <div className="satir">
            <span>Iskalama</span><b>{yuzde(rapor.isabetsizlikOrani[oyuncuTarafi])}</b>
          </div>
          <div className="satir">
            <span>Rakip ıskalama</span><b>{yuzde(rapor.isabetsizlikOrani[dusman])}</b>
          </div>
          {rapor.isabetsizlikOrani[oyuncuTarafi] > 0.25 && (
            <p className="ipucu">Çok ıskaladın — isabet değerin rakibin kaçınmasına yetmiyor.</p>
          )}
        </div>
      </div>

      <table className="dokum">
        <thead>
          <tr><th>Birim</th><th>Verdi</th><th>Aldı</th><th>Vuruş</th><th>Iska</th><th>Kritik</th><th /></tr>
        </thead>
        <tbody>
          {rapor.birimler.map((b) => (
            <tr key={b.id} className={b.taraf === oyuncuTarafi ? 'bizim' : 'rakip'}>
              <td>{b.id}{b.id === rapor.enCokHasarVeren && ' ★'}</td>
              <td>{b.verilenHasar}</td>
              <td>{b.alinanHasar}</td>
              <td>{b.vurusSayisi}</td>
              <td>{b.isabetsizSayisi}</td>
              <td>{b.kritikSayisi}</td>
              <td>{b.oldu ? '✝' : ''}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <button className="birincil" onClick={tekrar}>Yeni savaş</button>
    </div>
  )
}
